export default {
  additionalOrdersActivities: [],
  activitiesGroupedById: [],
  parentSuperorderActivities: [],
};
